import React from "react";

import CookieListHead from "./cookie-list-head";
import CookieListItem from "./cookie-list-item";

import "./CookieList.scss";

interface ICookie {
  name: string;
  provider: string;
  purpose: string;
  type: string;
  duration: string;
}

type CookieListProps = {
  items: ICookie[];
  heading?: string | null;
};

const CookieList: React.FC<CookieListProps> = ({
  items,
  heading = ""
}: CookieListProps) => {
  return (
    <div className="cookie-list">
      {heading && <h4 className="cookie-list__heading">{heading}</h4>}
      <div>
        <CookieListHead />
        {items.map((item) => (
          <CookieListItem
            key={item.name + item.provider}
            name={item.name}
            provider={item.provider}
            purpose={item.purpose}
            type={item.type}
            duration={item.duration}
          />
        ))}
      </div>
    </div>
  );
};

export default CookieList;
